import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a1d1727e")

_pushScopeId("data-v-a1d1727e")
const _hoisted_1 = { class: "md:flex flex-col md:flex-row md:min-h-screen mt-4 mx-4" }
const _hoisted_2 = {
  class: "md:col-span-1 md:grid-cols-1",
  style: {"display":"unset"}
}
const _hoisted_3 = { class: "mx-auto text-white md:col-span-3 md:grid-cols-3 justify-self-center lg:justify-self-stretch" }
const _hoisted_4 = { class: "text-center py-24 pb-20" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "overflow-hidden h-3.5 text-xs flex rounded-3xl bg-gray-200" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "shadow-none rounded-3xl flex flex-col text-center whitespace-nowrap text-white justify-center bg-bp",
    style: {"width":"50%"}
  })
], -1)
const _hoisted_6 = { class: "z-0 text-xl font-medium text-bp-dark bg-gray-70 text-center\n     p-5" }
const _hoisted_7 = { class: "z-0 text-xl font-medium text-bp-dark bg-gray-70 text-center\n     p-5" }
const _hoisted_8 = { class: "z-0 text-md font-medium text-bp-dark bg-gray-70 text-center\n     p-5 pt-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_sidebar_profile = _resolveComponent("sidebar-profile")
  const _component_btn_close = _resolveComponent("btn-close")
  const _component_router_link = _resolveComponent("router-link")
  const _component_default_button = _resolveComponent("default-button")
  const _component_default_card_layout = _resolveComponent("default-card-layout")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_sidebar_profile)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, { to: "/profile/shared" }, {
        default: _withId(() => [
          _createVNode(_component_btn_close, {
            "btn-position": "mr-7 mt-4",
            onClick: _ctx.cancelDialog
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_default_card_layout, null, {
        default: _withId(() => [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("h1", _hoisted_6, _toDisplayString($props.percentValue) + _toDisplayString($props.percentIndicator), 1),
            _createVNode("h1", _hoisted_7, _toDisplayString($props.itemsCountUploaded) + " " + _toDisplayString(_ctx.$t("profile.uploadBoostpack.from")) + " " + _toDisplayString($props.itemsCount) + " " + _toDisplayString(_ctx.$t("profile.uploadBoostpack.itemsUploadedText")), 1),
            _createVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("profile.uploadBoostpack.UploadedInfoText")), 1),
            _createVNode(_component_router_link, { to: "/profile/shared" }, {
              default: _withId(() => [
                _createVNode(_component_default_button, {
                  "button-text": _ctx.$t('modal.SubscribeDialog.closeBtn'),
                  "button-width": "w-auto",
                  "button-x-padding": "px-7"
                }, null, 8, ["button-text"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ])
  ]))
})